import axios from 'axios';

// 메타데이터 관련된 것들...
export default {
  getChannelMenu () { // Channels view 에 있는 나라, 카테고리 리스트
    return new Promise((resolve, reject) => {
      axios.get(`/v3/channel/menu`).then((response) => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  getStoreNation () { // store view 에 있는 카테고리 탭 목록
    return new Promise((resolve, reject) => {
      axios.get(`/v5/store/nation`).then((response) => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  getCommunityCategory () { // 리뉴얼 후 커뮤니티 필터 목록
    return new Promise((resolve, reject) => {
      axios.get(`/v5/community/category`).then((response) => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  postUserSuggestion (form) { // 문의, 제안 메일
    return new Promise((resolve, reject) => {
      axios.post(`/v2/user/suggestion`, form).then(response => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  getTimeInvalids () {
    return new Promise((resolve, reject) => {
      axios.get(`/v5/store/time/invalid`).then(response => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    })
  }
}
